module.exports = "/_next/static/images/5cf2a5243b46ff29f1d018c2553d7906-press-hero.jpg.webp";